var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 457 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f6f6",
    d: "M365.908 248.585c34.205 2.347 61.615-19.737 68.687-50.188c-12.398-17.568-38.4-25.911-61.335-11.355c-20.62 14.6-26.246 40.125-7.352 61.543zM273.305 10.732L149.51 79.105l28.627 15.02L301.826 25.96l-28.521-15.229zM155.843 198.79l120.942 275.98l32.289 19.834l-135.228-391.687l-32.211-17.27L12.87 328.604l23.497 13.187l110.998-144.02c2.428-2.719 6.49-2.807 8.478 1.02zm215.989 65.621c-35.172-19.361-35.172-68.029 0-87.39s79.376 4.971 79.376 43.695s-44.204 63.057-79.376 43.695zm39.955 36.412l45.06 131.37L319.247 512l-50.638-31.43l-90.68-206.734l-140.32 79.052L0 331.738L136.077 75.793L273.112 0l42.704 22.937l43.241 126.422c-83.56 46.07-41.566 162.873 52.73 151.464z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpo);
export default __webpack_public_path__ + "static/media/expo.aabb299625543272ced925ad3daddb47.svg";
export { ForwardRef as ReactComponent };